module.exports = __webpack_public_path__ + "static/img/B毫米波雷达.b293ea9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-3/智能碰撞预警系统/B毫米波雷达.png
// module id = xX54
// module chunks = 0